// src/pages/accounting/budget/BudgetYearlyList.jsx
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";


import { getAccessToken } from "../../../auth";
import styles from "./BudgetYearlyList.module.css";

const API = "/api/budget/documents/";

const BUSINESS_UNIT_OPTIONS = [
  { value: "", label: "전체 사업부" },



  { value: "management",       label: "경영지원" },
  { value: "service",          label: "용역사업" },
  { value: "env_total",        label: "환경위생(종합)" },
  { value: "env_disinfection", label: "환경위생(소독)" },
  { value: "cafe_gasan",       label: "카페(가산)" },
  { value: "cafe_doksan",      label: "카페(독산)" },
  { value: "cafe_geumnarae",   label: "카페(금나래)" },
  { value: "company",          label: "전사" },
];

const STATUS_BADGE = {
  draft:     { label: "작성중",   color: "#6c757d" },
  submitted: { label: "결재상신", color: "#0d6efd" },
  approved:  { label: "결재완료", color: "#198754" },
  locked:    { label: "잠금",    color: "#dc3545" },
  rejected:  { label: "반려",    color: "#fd7e14" },
};



export default function BudgetYearlyList() {
  const navigate = useNavigate();

  const currentYear = new Date().getFullYear();
  const [filterYear, setFilterYear] = useState(String(currentYear));
  const [filterBU,   setFilterBU]   = useState("");
  const [docs,       setDocs]       = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState("");

  const fetchDocs = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const params = new URLSearchParams();
      if (filterYear) params.set("fiscal_year", filterYear);
      if (filterBU)   params.set("business_unit", filterBU);

      const res = await fetch(`${API}?${params}`, {
        
        headers: { Authorization: `Bearer ${getAccessToken()}` },
      });
      if (!res.ok) throw new Error(`서버 오류 (${res.status})`);
      const data = await res.json();
      setDocs(data.results ?? data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [filterYear, filterBU]);

  useEffect(() => {
    fetchDocs();
  }, [fetchDocs]);

  // 연도 옵션: 현재 연도 기준 ±3
  const yearOptions = [];
  for (let y = currentYear + 1; y >= currentYear - 3; y--) {
    yearOptions.push(y);
  }

  return (
    <div className={styles.wrap}>
      {/* 헤더 */}
      <div className={styles.header}>
        <h2 className={styles.title}>연도별 예산서 목록</h2>
        <button
          className={styles.btnNew}
          onClick={() => navigate("/accounting/budget/yearly/new")}
        >
          + 예산서 업로드
        </button>
      </div>

      {/* 필터 */}
      <div className={styles.filterRow}>
        <select
          className={styles.select}
          value={filterYear}
          onChange={e => setFilterYear(e.target.value)}
        >
          <option value="">전체 연도</option>
          {yearOptions.map(y => (
            <option key={y} value={y}>{y}년</option>
          ))}
        </select>

        <select
          className={styles.select}
          value={filterBU}
          onChange={e => setFilterBU(e.target.value)}
        >
          {BUSINESS_UNIT_OPTIONS.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>

        <button className={styles.btnSearch} onClick={fetchDocs}>
          조회
        </button>
      </div>

      {/* 에러 */}
      {error && <p className={styles.error}>{error}</p>}

      {/* 테이블 */}
      {loading ? (
        <p className={styles.loading}>불러오는 중…</p>
      ) : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>연도</th>
                <th>사업부</th>
                <th>예산서명</th>
                <th>시트 수</th>
                <th>상태</th>
                <th>작성자</th>
                <th>등록일</th>
                <th>관리</th>
              </tr>
            </thead>
            <tbody>
              {docs.length === 0 ? (
                <tr>
                  <td colSpan={8} className={styles.empty}>
                    등록된 예산서가 없습니다.
                  </td>
                </tr>
              ) : (
                docs.map(doc => {
                  const badge = STATUS_BADGE[doc.status] ?? { label: doc.status, color: "#888" };
                  return (
                    <tr
                      key={doc.id}
                      className={styles.row}
                      onClick={() => navigate(`/accounting/budget/yearly/${doc.id}`)}
                    >
                      <td>{doc.fiscal_year}년</td>
                      <td>{doc.business_unit_display}</td>
                      <td className={styles.docTitle}>{doc.title}</td>
                      <td className={styles.center}>{doc.sheet_count}개</td>
                      <td className={styles.center}>
                        <span
                          className={styles.badge}
                          style={{ background: badge.color }}
                        >
                          {badge.label}
                        </span>
                      </td>
                      <td>{doc.created_by_name}</td>
                      <td>{doc.created_at?.slice(0, 10)}</td>
                      <td
                        className={styles.center}
                        onClick={e => e.stopPropagation()}
                      >
                        <button
                          className={styles.btnView}
                          onClick={() => navigate(`/accounting/budget/yearly/${doc.id}`)}
                        >
                          상세
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}